export const LOGIN = {
    REQUEST: 'LOGIN',
    PENDING: 'LOGIN_PENDING',
    FULFILLED: 'LOGIN_FULFILLED',
    REJECTED: 'LOGIN_REJECTED'
}
export const UPDATE_AUTH_FIELD = 'UPDATE_AUTH_FIELD'
export const LOGOUT = 'LOGOUT'
export const SET_JWT_TOKEN = 'SET_JWT_TOKEN'